import * as Pred from "fp-ts/Predicate";
import { flow } from "fp-ts/function";
import { invert } from "./Boolean";
import { concatAll } from "fp-ts/Monoid";
export const allPass = (fs) => concatAll(Pred.getMonoidAll())(fs);
export const anyPass = (fs) => concatAll(Pred.getMonoidAny())(fs);
export const nonePass = (fs) => flow(anyPass(fs), invert);
